module.exports = __webpack_public_path__ + "static/ISO9001Cert-7eedf978b03259108f1d9fd4f034f526.svg";